import { parseAppManifestFile } from "playground/apps/playground-json";
import { lazy, type ComponentType } from "react";
import { invariant } from "ts-invariant";

import { jigParseOptions } from "./install";

// Manifests are the catalog. Pane modules implement the host's rendered runtime.
export const availableJigs = Object.values(
  import.meta.glob("./*/playground.json", {
    eager: true,
    query: "?raw",
    import: "default",
  }),
)
  .map((text) => {
    invariant(typeof text === "string", "Expected jig manifest text");
    const result = parseAppManifestFile(text, jigParseOptions);
    invariant(result.ok, "Invalid bundled jig manifest");
    return {
      ...result.manifest,
      displayName: result.manifest.displayName ?? result.manifest.name,
    };
  })
  .sort((a, b) => a.displayName.localeCompare(b.displayName));

const panes = Object.fromEntries(
  Object.entries(
    import.meta.glob<{ default: ComponentType }>("./*/Pane.tsx"),
  ).map(([path, load]) => [path, lazy(load)]),
);

export function nativeJigPane(module: string) {
  const Pane = panes[`./${module}/Pane.tsx`];
  invariant(Pane, `Unknown Bear pane: ${module}`);
  return <Pane />;
}
